import React from 'react';
import heroPhoto from '../../assets/img/redesign/hero-consultation.jpg';

const Hero = () => (
    <div id="hero" className="sw-hero">
        <div className="sw-hero__grid-bg"/>
        <div className="sw-hero__glow--cyan"/>
        <div className="sw-hero__glow--orange"/>
        <div className="sw-container sw-hero__inner">
            <div className="sw-hero__copy">
                <div className="sw-hero__badge">
                    <div className="sw-hero__badge-dot"/>
                    <span>Wellness Support in Baltimore</span>
                </div>
                <h1 className="sw-heading sw-hero__title">
                    Care that meets you<br/><span>where you are.</span>
                </h1>
                <p className="sw-hero__lede">
                    You don’t have to face life’s challenges alone. Find support for your emotional health,
                    your recovery, and the everyday steps toward a more independent life.
                </p>
                <div className="sw-hero__actions">
                    <a href="#contact" className="sw-hero__btn-primary">Request an appointment</a>
                    <a href="#services" className="sw-hero__btn-ghost">Explore our services</a>
                </div>
                <div className="sw-hero__trust">
                    <span>Children, teens &amp; adults</span>
                    <span>Families &amp; veterans welcome</span>
                </div>
            </div>
            <div className="sw-hero__media">
                <img className="sw-hero__photo" src={heroPhoto} alt="A welcoming conversation in a counseling setting"/>
                <div className="sw-hero__note">
                    <strong>A first step, at your pace.</strong>
                    <small>Talk with our intake team.</small>
                </div>
            </div>
        </div>
    </div>
);

export default Hero;
